/******************************************************************************

 @File         PVRTPFXSemantics.h

 @Title        PFX Semantics

 @Version      

 @Copyright    Copyright (c) Imagination Technologies Limited.

 @Platform     All

 @Description  A list of supported PFX semantics.

******************************************************************************/

import PVRShader from './PVRShader'
import {ETexturFilter, ETextureWrap , ESemanticDefaultDataType} from "./PVREffectParser"

const PVRTEX_CUBEMAP = 1<<12;
// struct SPVRTPFXUniformSemantic;
/****************************************************************************
** Semantic Enumerations
****************************************************************************/
export const EPVRTPFXUniformSemantic =
{
	ePVRTPFX_UsPOSITION : 0,
	ePVRTPFX_UsNORMAL : 1,
	ePVRTPFX_UsTANGENT: 2,
	ePVRTPFX_UsBINORMAL: 3,
	ePVRTPFX_UsUV : 4,
	ePVRTPFX_UsVERTEXCOLOR: 5,
	ePVRTPFX_UsBONEINDEX:6,
	ePVRTPFX_UsBONEWEIGHT:7,

	ePVRTPFX_UsWORLD:8,
	ePVRTPFX_UsWORLDI:9,
	ePVRTPFX_UsWORLDIT:10,
	ePVRTPFX_UsVIEW:11,
	ePVRTPFX_UsVIEWI:12,
	ePVRTPFX_UsVIEWIT:!3,
	ePVRTPFX_UsPROJECTION:14,
	ePVRTPFX_UsPROJECTIONI:15,
	ePVRTPFX_UsPROJECTIONIT:16,
	ePVRTPFX_UsWORLDVIEW:17,
	ePVRTPFX_UsWORLDVIEWI:18,
	ePVRTPFX_UsWORLDVIEWIT:19,
	ePVRTPFX_UsWORLDVIEWPROJECTION:20,
	ePVRTPFX_UsWORLDVIEWPROJECTIONI:21,
	ePVRTPFX_UsWORLDVIEWPROJECTIONIT:22,
	ePVRTPFX_UsVIEWPROJECTION:23,
	ePVRTPFX_UsVIEWPROJECTIONI:24,
	ePVRTPFX_UsVIEWPROJECTIONIT:25,
	ePVRTPFX_UsOBJECT:26,
	ePVRTPFX_UsOBJECTI:27,
	ePVRTPFX_UsOBJECTIT:28,
	ePVRTPFX_UsUNPACKMATRIX:29,

	ePVRTPFX_UsBONECOUNT:30,
	ePVRTPFX_UsBONEMATRIXARRAY:31,
	ePVRTPFX_UsBONEMATRIXARRAYIT:32,

	ePVRTPFX_UsMATERIALOPACITY:33,
	ePVRTPFX_UsMATERIALSHININESS:34,
	ePVRTPFX_UsMATERIALCOLORAMBIENT:35,
	ePVRTPFX_UsMATERIALCOLORDIFFUSE:36,
	ePVRTPFX_UsMATERIALCOLORSPECULAR:37,

	ePVRTPFX_UsLIGHTCOLOR:38,
	ePVRTPFX_UsLIGHTPOSMODEL:39,
	ePVRTPFX_UsLIGHTPOSWORLD:40,
	ePVRTPFX_UsLIGHTPOSEYE:41,
	ePVRTPFX_UsLIGHTDIRMODEL:42,
	ePVRTPFX_UsLIGHTDIRWORLD:43,
	ePVRTPFX_UsLIGHTDIREYE:44,
	ePVRTPFX_UsLIGHTATTENUATION:45,
	ePVRTPFX_UsLIGHTFALLOFF:46,

	ePVRTPFX_UsEYEPOSMODEL:47,
	ePVRTPFX_UsEYEPOSWORLD:48,
	ePVRTPFX_UsTEXTURE:49,
	ePVRTPFX_UsANIMATION:50,

	ePVRTPFX_UsVIEWPORTPIXELSIZE:51,
	ePVRTPFX_UsVIEWPORTCLIPPING:52,
	ePVRTPFX_UsTIME:53,
	ePVRTPFX_UsTIMECOS:54,
	ePVRTPFX_UsTIMESIN:55,
	ePVRTPFX_UsTIMETAN:56,
	ePVRTPFX_UsTIME2PI:57,
	ePVRTPFX_UsTIME2PICOS:58,
	ePVRTPFX_UsTIME2PISIN:59,
	ePVRTPFX_UsTIME2PITAN:60,
	ePVRTPFX_UsRANDOM:61,

	ePVRTPFX_NumSemantics:62,
};

//const SPVRTPFXUniformSemantic* PVRTPFXSemanticsGetSemanticList();


/****************************************************************************
** Structures
****************************************************************************/

/*! Application supplies an array of these so PVRTPFX can translate strings to numbers */
const SPVRTPFXUniformSemantic = function(p,n)
{
        this.p = "" ;	// String containing semantic
        if(p)  this.p = p;
        this.n = 0;
        if(n)  this.n = n;	// Application-defined semantic value  //unsigned int
};

/*!***************************************************************************
** Default Shaman semantics
*****************************************************************************/
const  c_psSemanticsInfo =   //SPVRTPFXUniformSemantic
[
	new SPVRTPFXUniformSemantic( "POSITION",				EPVRTPFXUniformSemantic.ePVRTPFX_UsPOSITION					),
	new SPVRTPFXUniformSemantic( "NORMAL",					EPVRTPFXUniformSemantic.ePVRTPFX_UsNORMAL					),
	new SPVRTPFXUniformSemantic( "TANGENT",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTANGENT 					),		
	new SPVRTPFXUniformSemantic( "BINORMAL",				EPVRTPFXUniformSemantic.ePVRTPFX_UsBINORMAL 				),
	new SPVRTPFXUniformSemantic( "UV",						EPVRTPFXUniformSemantic.ePVRTPFX_UsUV						),
	new SPVRTPFXUniformSemantic( "VERTEXCOLOR",			EPVRTPFXUniformSemantic.ePVRTPFX_UsVERTEXCOLOR				),
	new SPVRTPFXUniformSemantic( "BONEINDEX",				EPVRTPFXUniformSemantic.ePVRTPFX_UsBONEINDEX				),
	new SPVRTPFXUniformSemantic( "BONEWEIGHT",				EPVRTPFXUniformSemantic.ePVRTPFX_UsBONEWEIGHT				),

	new SPVRTPFXUniformSemantic( "WORLD",					EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLD					),
	new SPVRTPFXUniformSemantic( "WORLDI",					EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDI 					),
	new SPVRTPFXUniformSemantic( "WORLDIT",				EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDIT					),
	new SPVRTPFXUniformSemantic( "VIEW",					EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEW 					),
	new SPVRTPFXUniformSemantic( "VIEWI",					EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWI 					),
	new SPVRTPFXUniformSemantic( "VIEWIT",					EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWIT					),
	new SPVRTPFXUniformSemantic( "PROJECTION",				EPVRTPFXUniformSemantic.ePVRTPFX_UsPROJECTION				),
	new SPVRTPFXUniformSemantic( "PROJECTIONI",			EPVRTPFXUniformSemantic.ePVRTPFX_UsPROJECTIONI				),
	new SPVRTPFXUniformSemantic( "PROJECTIONIT",			EPVRTPFXUniformSemantic.ePVRTPFX_UsPROJECTIONIT				),
	new SPVRTPFXUniformSemantic( "WORLDVIEW",				EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEW				),
	new SPVRTPFXUniformSemantic( "WORLDVIEWI",				EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWI				),
	new SPVRTPFXUniformSemantic( "WORLDVIEWIT",			EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWIT				),
	new SPVRTPFXUniformSemantic( "WORLDVIEWPROJECTION",	EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWPROJECTION		),
	new SPVRTPFXUniformSemantic( "WORLDVIEWPROJECTIONI",	EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWPROJECTIONI		),
	new SPVRTPFXUniformSemantic( "WORLDVIEWPROJECTIONIT",	EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWPROJECTIONIT	),
	new SPVRTPFXUniformSemantic( "UNPACKMATRIX",			EPVRTPFXUniformSemantic.ePVRTPFX_UsUNPACKMATRIX				),

	new SPVRTPFXUniformSemantic( "VIEWPROJECTION",			EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWPROJECTION			),
	new SPVRTPFXUniformSemantic( "VIEWPROJECTIONI",		EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWPROJECTIONI			),
	new SPVRTPFXUniformSemantic( "VIEWPROJECTIONIT",		EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWPROJECTIONIT			),
	new SPVRTPFXUniformSemantic( "OBJECT",					EPVRTPFXUniformSemantic.ePVRTPFX_UsOBJECT,					),
	new SPVRTPFXUniformSemantic( "OBJECTI",				EPVRTPFXUniformSemantic.ePVRTPFX_UsOBJECTI,					),
	new SPVRTPFXUniformSemantic( "OBJECTIT",				EPVRTPFXUniformSemantic.ePVRTPFX_UsOBJECTIT,				),

	new SPVRTPFXUniformSemantic( "MATERIALOPACITY",		EPVRTPFXUniformSemantic.ePVRTPFX_UsMATERIALOPACITY			),
	new SPVRTPFXUniformSemantic( "MATERIALSHININESS",		EPVRTPFXUniformSemantic.ePVRTPFX_UsMATERIALSHININESS		),
	new SPVRTPFXUniformSemantic( "MATERIALCOLORAMBIENT",	EPVRTPFXUniformSemantic.ePVRTPFX_UsMATERIALCOLORAMBIENT		),
	new SPVRTPFXUniformSemantic( "MATERIALCOLORDIFFUSE",	EPVRTPFXUniformSemantic.ePVRTPFX_UsMATERIALCOLORDIFFUSE 	),
	new SPVRTPFXUniformSemantic( "MATERIALCOLORSPECULAR",	EPVRTPFXUniformSemantic.ePVRTPFX_UsMATERIALCOLORSPECULAR	),

	new SPVRTPFXUniformSemantic( "BONECOUNT",				EPVRTPFXUniformSemantic.ePVRTPFX_UsBONECOUNT				),
	new SPVRTPFXUniformSemantic( "BONEMATRIXARRAY",		EPVRTPFXUniformSemantic.ePVRTPFX_UsBONEMATRIXARRAY			),
	new SPVRTPFXUniformSemantic( "BONEMATRIXARRAYIT",		EPVRTPFXUniformSemantic.ePVRTPFX_UsBONEMATRIXARRAYIT		),

	new SPVRTPFXUniformSemantic( "LIGHTCOLOR",				EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTCOLOR				),
	new SPVRTPFXUniformSemantic( "LIGHTPOSMODEL",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTPOSMODEL 			),
	new SPVRTPFXUniformSemantic( "LIGHTPOSWORLD",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTPOSWORLD			),
	new SPVRTPFXUniformSemantic( "LIGHTPOSEYE",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTPOSEYE				),
	new SPVRTPFXUniformSemantic( "LIGHTDIRMODEL",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTDIRMODEL			),
	new SPVRTPFXUniformSemantic( "LIGHTDIRWORLD",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTDIRWORLD			),
	new SPVRTPFXUniformSemantic( "LIGHTDIREYE",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTDIREYE				),
	new SPVRTPFXUniformSemantic( "LIGHTATTENUATION",		EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTATTENUATION			),
	new SPVRTPFXUniformSemantic( "LIGHTFALLOFF",			EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTFALLOFF				),

	new SPVRTPFXUniformSemantic( "EYEPOSMODEL",			EPVRTPFXUniformSemantic.ePVRTPFX_UsEYEPOSMODEL				),
	new SPVRTPFXUniformSemantic( "EYEPOSWORLD",			EPVRTPFXUniformSemantic.ePVRTPFX_UsEYEPOSWORLD				),
	new SPVRTPFXUniformSemantic( "TEXTURE",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTEXTURE					),
	new SPVRTPFXUniformSemantic( "ANIMATION",				EPVRTPFXUniformSemantic.ePVRTPFX_UsANIMATION				),
	
	new SPVRTPFXUniformSemantic( "VIEWPORTPIXELSIZE",		EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWPORTPIXELSIZE		),
	new SPVRTPFXUniformSemantic( "VIEWPORTCLIPPING",		EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWPORTCLIPPING			),
	new SPVRTPFXUniformSemantic( "TIME",					EPVRTPFXUniformSemantic.ePVRTPFX_UsTIME						),
	new SPVRTPFXUniformSemantic( "TIMECOS",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIMECOS					),
	new SPVRTPFXUniformSemantic( "TIMESIN",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIMESIN					),
	new SPVRTPFXUniformSemantic( "TIMETAN",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIMETAN,					),
	new SPVRTPFXUniformSemantic( "TIME2PI",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIME2PI,					),
	new SPVRTPFXUniformSemantic( "TIME2PICOS",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIME2PICOS,				),
	new SPVRTPFXUniformSemantic( "TIME2PISIN",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIME2PISIN,				),
	new SPVRTPFXUniformSemantic( "TIME2PITAN",				EPVRTPFXUniformSemantic.ePVRTPFX_UsTIME2PITAN,				),
	new SPVRTPFXUniformSemantic( "RANDOM",					EPVRTPFXUniformSemantic.ePVRTPFX_UsRANDOM,					),
    ];


//PVRTCOMPILEASSERT(c_psSemanticsInfo, sizeof(c_psSemanticsInfo) / sizeof(c_psSemanticsInfo[0]) == ePVRTPFX_NumSemantics);

const PVRTPFXSemanticsGetSemanticList= function()  //SPVRTPFXUniformSemantic* 
{
	return c_psSemanticsInfo;
}

/*****************************************************************************
 End of file (PVRTPFXSemantics.cpp)
*****************************************************************************/


// /******************************************************************************

//  @File         PVRTPFXParserAPI.h

//  @Title        OGLES2/PVRTPFXParserAPI.h

//  @Version      

//  @Copyright    Copyright (c) Imagination Technologies Limited.

//  @Platform     Windows + Linux

//  @Description  Declaration of PFX file parser

// ******************************************************************************/

// #ifndef _PVRTPFXPARSERAPI_H_
// #define _PVRTPFXPARSERAPI_H_

// #include "../PVRTError.h"



/*! PVRTPFX returns an array of these to indicate GL locations & semantics to the application */
const SPVRTPFXUniform = function()
{
    this.nLocation = 0;	//unsigned int // GL location of the Uniform
	this.nSemantic = 0;	   //	unsigned int // Application-defined semantic value
	this.nIdx  = 0;		 //unsigned int	// Index; for example two semantics might be LIGHTPOSITION0 and LIGHTPOSITION1
	this.sValueName = "";	  //	CPVRTString		// The name of the variable referenced in shader code
};

/*! An array of these is gained from PVRTPFX so the application can fill in the texture handles*/
const SPVRTPFXTexture = function()
{
		this.name = "";		 //CPVRTStringHash	// texture name
    	this.ui = {};	//	GLuint				// Loaded texture handle
		this.unit = {};  //GLuint	// The bound texture unit
		this.flags = 0;	//unsigned int	 // Texture type i.e 2D, Cubemap
};

// class PVRTPFXEffectDelegate
// {
// //public:
// 	virtual EPVRTError PVRTPFXOnLoadTexture(const CPVRTStringHash& TextureName, GLuint& uiHandle, unsigned int& uiFlags) = 0;
// 	//virtual ~PVRTPFXEffectDelegate() { }
// };

/*!**************************************************************************
@Class PVRPFXEffect
@Brief PFX effect
****************************************************************************/



// 	/*!***************************************************************************
// 	@Function			PVRPFXEffect Blank Constructor
// 	@Description		Sets the context to NULL and initialises the member variables to zero.
// 	*****************************************************************************/
// //	PVRPFXEffect();

// 	/*!***************************************************************************
// 	@Function			PVRPFXEffect Constructor
// 	@Description		Sets the context and initialises the member variables to zero.
// 	*****************************************************************************/
// 	PVRPFXEffect(SPVRTContext &sContext);

// 	/*!***************************************************************************
// 	@Function			PVRPFXEffect Destructor
// 	@Description		Calls Destroy().
// 	*****************************************************************************/
// 	~PVRPFXEffect();

// 	/*!***************************************************************************
// 	@Function			Load
// 	@Input				src					PFX Parser Object
// 	@Input				pszEffect			Effect name
// 	@Input				pszFileName			Effect file name
// 	@Input				pDelegate			A delegate which will receive callbacks
// 	@Output				uiUnknownUniforms	Number of unknown uniforms found
// 	@Output				pReturnError		Error string
// 	@Returns			true if load succeeded
// 	@Description		Loads the specified effect from the CPVRTPFXParser object.
// 						Compiles and links the shaders. Initialises texture data.
// 	*****************************************************************************/
// 	EPVRTError Load(CPVRTPFXParser &src, const char * const pszEffect, const char * const pszFileName, 
// 					PVRTPFXEffectDelegate* pDelegate, unsigned int& uiUnknownUniforms, CPVRTString *pReturnError);

// 	/*!***************************************************************************
// 	@Function			Destroy
// 	@Description		Deletes the gl program object and texture data.
// 	*****************************************************************************/
// 	void Destroy();

// 	/*!***************************************************************************
// 	@Function			Activate
// 	@Input				i32RenderTextureId		The ID of the render target of the current task
// 	@Input				ui32ReplacementTexture	The ID of the texture that should be used instead
// 	@Returns			EPVRTError				true if activate succeeded
// 	@Description		Selects the gl program object and binds the textures.
// 						If the render target texture for the current render pass is required
// 						in this effect (and therefore cannot be sampled),
// 						load the replacement texture instead.
// 	*****************************************************************************/
// 	EPVRTError Activate(const int i32RenderTextureId=-1, const unsigned int ui32ReplacementTexture=0);

// 	/*!***************************************************************************
// 	@Function			GetTextureArray
// 	@Returns			SPVRTPFXTexture*		pointer to the texture data array
// 	@Description		Gets the texture data array.
// 	*****************************************************************************/
// 	const CPVRTArray<SPVRTPFXTexture>& GetTextureArray() const;

// 	/*!***************************************************************************
// 	@Function		GetUniformArray
// 	@Return			const CPVRTArray<SPVRTPFXUniform>&	
// 	@Description	Returns a list of known semantics.
// 	*****************************************************************************/
// 	const CPVRTArray<SPVRTPFXUniform>& GetUniformArray() const;

// 	/*!***************************************************************************
// 	@Function		GetSemanticArray
// 	@Return			const CPVRTArray<SPVRTPFXUniformSemantic>&	
// 	@Description	Gets the array of registered semantics which will be used to
// 	match PFX code.
// 	*****************************************************************************/
// 	const CPVRTArray<SPVRTPFXUniformSemantic>& GetSemanticArray() const;

// 	/*!***************************************************************************
// 	@Function			SetTexture
// 	@Input				nIdx				texture number
// 	@Input				ui					opengl texture handle
// 	@Input				u32flags			texture flags
// 	@Description		Sets the textrue and applys the filtering.
// 	*****************************************************************************/
// 	void SetTexture(const unsigned int nIdx, const GLuint ui, const unsigned int u32flags=0);

// 	/*!***************************************************************************
// 	@Function			SetDefaultSemanticValue
// 	@Input				pszName				name of uniform
// 	@Input				psDefaultValue      pointer to default value
// 	@Description		Sets the dafault value for the uniform semantic.
// 	*****************************************************************************/
// 	void SetDefaultUniformValue(const char *const pszName, const SPVRTSemanticDefaultData *psDefaultValue);

// 	/*!***************************************************************************
// 	@Function		RegisterUniformSemantic
// 	@Input			psUniforms			Array of semantics to register
// 	@Input			uiNumUniforms		Number provided
// 	@Output			pReturnError		Human-readable error if any
// 	@Return			true on success	
// 	@Description	Registers a user-provided uniform semantic.
// 	*****************************************************************************/
// 	EPVRTError RegisterUniformSemantic(const SPVRTPFXUniformSemantic* const psUniforms, unsigned int uiNumUniforms, CPVRTString* pReturnError);

// 	/*!***************************************************************************
// 	@Function		RemoveUniformSemantic
// 	@Input			uiSemanticID
// 	@Output			pReturnError
// 	@Return			true on success	
// 	@Description	Removes a given semantic ID from the 'known' semantic list and 
// 					re-parses the effect to update the uniform table.
// 	*****************************************************************************/
// 	EPVRTError RemoveUniformSemantic(unsigned int uiSemanticID, CPVRTString* pReturnError);

// 	/*!***************************************************************************
// 	 @Function			SetContext
// 	 @Input				pContext			context pointer
// 	 @Description		Sets the context for this effect.
// 	 *****************************************************************************/
// 	void SetContext(SPVRTContext * const pContext);
	
// 	/*!***************************************************************************
// 	@Function		GetProgramHandle
// 	@Return			unsigned int	
// 	@Description	Returns the OGL program handle.
// 	*****************************************************************************/
// 	unsigned int GetProgramHandle() const;

// 	/*!***************************************************************************
// 	@Function		GetEffectIndex
// 	@Return			unsigned int	
// 	@Description	Gets the active effect index within the PFX file.
// 	*****************************************************************************/
// 	unsigned int GetEffectIndex() const;

// private:
// 	/*!***************************************************************************
// 	@Function		LoadShadersForEffect
// 	@Input			pszFileName
// 	@Output			pReturnError
// 	@Return			EPVRTError	
// 	@Description	Loads all of the GLSL shaders for an effect.
// 	*****************************************************************************/
// 	EPVRTError LoadShadersForEffect(CPVRTPFXParser &src, const char * const pszFileName, CPVRTString *pReturnError);

// 	/*!***************************************************************************
// 	@Function		LoadTexturesForEffect
// 	@Output			pReturnError
// 	@Return			EPVRTError	
// 	@Description	Loads all of the textures for this effect.
// 	*****************************************************************************/
// 	EPVRTError LoadTexturesForEffect(PVRTPFXEffectDelegate* pDelegate, CPVRTString *pReturnError);

// 	/*!***************************************************************************
// 	@Function		BuildUniformTable
// 	@Output			uiUnknownSemantics
// 	@Output			pReturnError
// 	@Return			EPVRTError	
// 	@Description	Builds the uniform table from a list of known semantics.
// 	*****************************************************************************/
// 	EPVRTError RebuildUniformTable(unsigned int& uiUnknownSemantics, CPVRTString* pReturnError);

// protected:
// 	bool									m_bLoaded;
// 	SPVRTContext*							this.m_psContext;
// 	CPVRTPFXParser*							m_pParser;
// 	unsigned int							this.m_nEffect;

// 	GLuint									this.m_uiProgram;		// Loaded program

// 	CPVRTArray<SPVRTPFXTexture>				this.m_Textures;			// Array of loaded textures
// 	CPVRTArray<SPVRTPFXUniform>				this.m_Uniforms;			// Array of found uniforms

// 	CPVRTArray<SPVRTPFXUniformSemantic>		this.m_Semantics;		// An array of registered semantics.
// };

/****************************************************************************
** Auxiliary functions
****************************************************************************/
// inline bool operator==(const SPVRTPFXUniformSemantic& lhs, const SPVRTPFXUniformSemantic& rhs)
// {
// 	return (lhs.n == rhs.n);
// }

//</SPVRTPFXUniformSemantic>#endif /* _PVRTPFXPARSERAPI_H_ */

/*****************************************************************************
 End of file (PVRTPFXParserAPI.h)
*****************************************************************************/







/*****************************************************************************
 End of file (PVRTPFXSemantics.h)
*****************************************************************************/



// /******************************************************************************

//  @File         PVRTPFXParserAPI.cpp

//  @Title        PVRTPFXParserAPI

//  @Version      

//  @Copyright    Copyright (c) Imagination Technologies Limited.

//  @Platform     ANSI compatible

//  @Description  PFX file parser.

//</SPVRTPFXUniform>******************************************************************************/

/*****************************************************************************
** Includes
// *****************************************************************************/
// #include <stdio.h>
// #include <string.h>
// #include <stdlib.h>

// #include "PVRTContext.h"
// #include "PVRTMatrix.h"
// #include "PVRTFixedPoint.h"
// #include "PVRTString.h"
// #include "PVRTShader.h"
// #include "PVRTPFXParser.h"
// #include "PVRTPFXParserAPI.h"
// #include "PVRTPFXSemantics.h"
// #include "PVRTTexture.h"
// #include "PVRTTextureAPI.h"

/*!***************************************************************************
 @Function			PVRPFXEffect Constructor
 @Description		Sets the context and initialises the member variables to zero.
*****************************************************************************/
export const PVRPFXEffect = function(sContext){


  		// Array of found uniforms  // CPVRTArray<SPVRTPFXUniform>	</SPVRTPFXTexture>
   
  
 
 
  //SPVRTContext
    



       //</string.h>{




/*!***************************************************************************
 @Function			PVRPFXEffect Destructor
 @Description		Calls Destroy().
*****************************************************************************/
 PVRPFXEffect.prototype.destructor = function(gl)
{
	this.destroy(gl);
	
	// Free allocated strings
	for(let uiIndex = EPVRTPFXUniformSemantic.ePVRTPFX_NumSemantics; uiIndex < this.m_Semantics.length; ++uiIndex)
	{
		//this.m_Semantics[uiIndex].p\
		this.m_Semantics[uiIndex].p = null;
	}
}

/*!***************************************************************************
 @Function			Load
 @Input				src					PFX Parser Object
 @Input				pszEffect			Effect name
 @Input				pszFileName			Effect file name
 @Output			pReturnError		Error string
 @Returns			EPVRTError			true if load succeeded
 @Description		Loads the specified effect from the CPVRTPFXParser object.
					Compiles and links the shaders. Initialises texture data.
*****************************************************************************/
//PVRPFXEffect.prototype.load = function (CPVRTPFXParser &src, const char * const pszEffect, const char * const pszFileName, 
//								PVRTPFXEffectDelegate* pDelegate, unsigned int& uiUnknownUniforms, CPVRTString *pReturnError)
PVRPFXEffect.prototype.load = function(gl, src,  pszEffect, pszFileName, pDelegate, uiUnknownUniforms, callback){


	// if (sContext) { this.m_psContext = sContext; }
	// else{
   
	   this.m_bLoaded = false;
	   this.m_psContext = null;
	   this.m_pParser = null;
	   this.m_nEffect = 0;
	   this.m_uiProgram = 0;
	if(!this.m_Semantics)   this.m_Semantics =  new PVRTPFXSemanticsGetSemanticList();//</stdlib.h> EPVRTPFXUniformSemantic.ePVRTPFX_NumSemantics]
	
	   this.m_Textures = [];		 // CPVRTArray<SPVRTPFXTexture>	</stdlib.h>	// Array of loaded textures
	   this.m_Uniforms = [];	
	//} 



	if(!src.getNumberEffects())
		return false;

	// --- First find the named effect from the effect file
	if(pszEffect)
	{
		let iEffect =  src.findEffectByName(pszEffect); // src.findEffectByName(CPVRTStringHash(pszEffect));
		if(iEffect === -1)	return false;

		this.m_nEffect = iEffect; //(unsigned int)</stdio.h>

	}
	else
	{
		this.m_nEffect = 0;
	}


	// --- Now load the effect
	this.m_pParser = src;
	const  parserEffect = src.getEffect(this.m_nEffect); //SPVRTPFXParserEffect 

	// Create room for per-texture data
	const  EffectTextures = src.getEffect(this.m_nEffect).textures;   //CPVRTArray<SPVRTPFXParserEffectTexture>&


	let uiNumTexturesForEffect = EffectTextures.length;  //unsigned int
	this.m_Textures  =   []; //new Array(uiNumTexturesForEffect);  //.setCapacity(uiNumTexturesForEffect);

	// Initialise each Texture
	for(let i = 0; i < uiNumTexturesForEffect; i++)
	{
		let iTexIdx = src.findTextureByName(EffectTextures[i].name);
		if(iTexIdx < 0.0)
		{
			console.log("ERROR: Effect '%s' requests non-existent texture: %s\n" + parserEffect.name+ EffectTextures[i].name);
			return false;
		}

        let uiTexIdx = this.m_Textures.length;
        this.m_Textures.push(new SPVRTPFXTexture());
		this.m_Textures[uiTexIdx].name	= src.getTexture(iTexIdx).name;  //(unsigned int)
		this.m_Textures[uiTexIdx].ui		= 0xFFFFFFFF;
		this.m_Textures[uiTexIdx].flags	= 0;
		this.m_Textures[uiTexIdx].unit	= 0;
	}


	// Load the shaders
	if(this.loadShadersForEffect(gl, src, pszFileName) !== true)
		return false;

	// Build uniform table
	if(this.rebuildUniformTable(gl, uiUnknownUniforms) !== true)
		return false;

	// Load the requested textures
	if(pDelegate)
	{
		if(!this.loadTexturesForEffect(gl, pDelegate)) return false;
	}

	this.m_bLoaded = true;

    if(typeof callback == "function")
    {
		//let args = [gl, textureID, pvrHeader, pvrMetaData];
		let args = [gl];
        args = args.concat(Array.prototype.slice.call(arguments, 7));
      
        callback.apply(null, args);
	}

	return true;
}

/*!***************************************************************************
@Function		LoadTexturesForEffect
@Output			pReturnError
@Return			EPVRTError	
@Description	Loads all of the textures for this effect.
*****************************************************************************/
//</SPVRTPFXParserEffectTexture>PVRPFXEffect.prototype.loadTexturesForEffect = function(PVRTPFXEffectDelegate* pDelegate, CPVRTString *pReturnError)

PVRPFXEffect.prototype.loadTexturesForEffect = function(gl, pDelegate){
	let	uiHandle = {} //GLuint
	let	uiFlags = {} //unsigned int
	
	for(let i = 0; i < this.m_Textures.length; ++i)
	{
		let iTexID = this.m_pParser.findTextureByName(this.m_Textures[i].name);
		if(iTexID === -1)
		{
			console.log("ERROR: Cannot find texture '%s' in any TEXTURE block.\n"+ this.m_Textures[i].name);
			return false;
		}

		const pTexDesc = this.m_pParser.getTexture(iTexID);  //SPVRTPFXParserTexture* 
		
		
		uiHandle = 0xBADF00D;
		uiFlags  = 0;

		
if(pDelegate.PVRTPFXOnLoadTexture(pTexDesc.fileName, uiHandle, uiFlags) !== true)
		{
			console.log("ERROR: Failed to load texture: %s.\n", pTexDesc.fileName);
			return false;
		}
	
		// Make sure uiHandle was written.
		if(uiHandle === 0xBADF00D)
		{
			alert("error");
			console.log("ERROR: GL handle for texture '%s' not set!\n", pTexDesc.fileName);
			return false;
		}
		
		this.setTexture(gl, i, uiHandle, uiFlags);
	}

	return true;
}

/*!***************************************************************************
@Function		LoadShadersForEffect
@Input			pszFileName
@Output			pReturnError
@Return			EPVRTError	
@Description	Loads all of the GLSL shaders for an effect.
*****************************************************************************/
 //PVRPFXEffect.prototype.loadShadersForEffect  = function (CPVRTPFXParser &src, const char * const pszFileName, CPVRTString *pReturnError)
 PVRPFXEffect.prototype.loadShadersForEffect  = function (gl, src, pszFileName){
	// initialise attributes to default values
	let pszVertexShader		= null;
	let pszFragmentShader		= null;
	let bFreeVertexShader		= false;
	let bFreeFragmentShader	= false;
	let uiVertIdx		= 0;  //unsigned int 
	let uiFragIdx		= 0;
	let uiVertexShader	= {};
	let uiFragShader	= {};


	const  parserEffect = src.getEffect(this.m_nEffect); //SPVRTPFXParserEffect

	// find shaders requested
	for(uiVertIdx = 0; uiVertIdx < src.getNumberVertexShaders(); ++uiVertIdx)
	{
		const vertexShader = src.getVertexShader(uiVertIdx); //const SPVRTPFXParserShader&
        
        if(parserEffect.vertexShaderName === vertexShader.name)
		{
		


			if(vertexShader.bUseFileName)
			{
				pszVertexShader = vertexShader.pszGLSLcode;
			}
			else
			{
				if(!vertexShader.pszGLSLcode) continue;			// No code specified.
                 // #if 0
              // 				// offset glsl code by nFirstLineNumber
        // 				pszVertexShader = (char *)malloc((strlen(VertexShader.pszGLSLcode) + (VertexShader.nFirstLineNumber) + 1) * sizeof(char));
        // 				pszVertexShader[0] = '\0';
         // 			 	for(unsigned int n = 0; n < VertexShader.nFirstLineNumber; n++)
            // 					strcat(pszVertexShader, "\n");
                // 				strcat(pszVertexShader, VertexShader.pszGLSLcode);
                // #else
            
                pszVertexShader= vertexShader.pszGLSLcode;
                // pszVertexShader = (char *)malloc(strlen(VertexShader.pszGLSLcode) + 1);
				// pszVertexShader[0] = '\0';
				// strcat(pszVertexShader, VertexShader.pszGLSLcode);
                //#endif
				bFreeVertexShader = true;
			}

			break;
		}
	}

	for(uiFragIdx = 0; uiFragIdx < src.getNumberFragmentShaders(); ++uiFragIdx)
	{
		const fragmentShader = src.getFragmentShader(uiFragIdx); //SPVRTPFXParserShader& 
   
        if(parserEffect.fragmentShaderName === fragmentShader.name)
		{
		

			if(fragmentShader.bUseFileName)
			{
				pszFragmentShader = fragmentShader.pszGLSLcode;
			}
			else
			{
				if(!fragmentShader.pszGLSLcode) continue;			// No code specified.

               // #if 0
                // 				// offset glsl code by nFirstLineNumber
              // 				pszFragmentShader = (char *)malloc((strlen(FragmentShader.pszGLSLcode) + (FragmentShader.nFirstLineNumber) + 1) * sizeof(char));
              // 				pszFragmentShader[0] = '\0';
                  // 				for(unsigned int n = 0; n < FragmentShader.nFirstLineNumber; n++)
                   //               / 					strcat(pszFragmentShader, "\n");
                  // 				strcat(pszFragmentShader, FragmentShader.pszGLSLcode);
                  // #else
            
                  pszFragmentShader =  fragmentShader.pszGLSLcode;
                  // pszFragmentShader = (char *)malloc(strlen(FragmentShader.pszGLSLcode) + 1);
                   // 				pszFragmentShader[0] = '\0';
                    // 				strcat(pszFragmentShader, FragmentShader.pszGLSLcode);
                     //#endif
				bFreeFragmentShader = true;
			}

			break;
		}
	}

	//CPVRTString error;
	  let		bLoadSource = 1;

	// Try first to load from the binary block
	if (src.getVertexShader(uiVertIdx).pbGLSLBinary !== null)
	{
            // #if defined(GL_SGX_BINARY_IMG)
            // 		if (PVRTShaderLoadBinaryFromMemory(src.GetVertexShader(uiVertIdx).pbGLSLBinary, src.GetVertexShader(uiVertIdx).nGLSLBinarySize,
            // 			GL_VERTEX_SHADER, GL_SGX_BINARY_IMG, &uiVertexShader, &error) == true)
            // 		{
            // 			// success loading the binary block so we do not need to load the source
            // 			bLoadSource = 0;
            // 		}
            // 		else
            // #endif
            // 		{
			bLoadSource = 1;
                //}
	}

	// If it fails, load from source
	if (bLoadSource)
	{

		    if(pszVertexShader)
	       	{

				
                 uiVertexShader = PVRShader.loadFromMemory(gl, pszVertexShader, gl.VERTEX_SHADER, [] )  //!== true)
			   // if (PVRTShaderLoadSourceFromMemory(pszVertexShader, gl.VERTEX_SHADER, &uiVertexShader, &error) != true)
		
				// console.log("ERROR: Vertex Shader compile error in file '" + pszFileName + "':\n");
				// if(bFreeVertexShader) pszVertexShader = null;
                // if(bFreeFragmentShader)	pszFragmentShader = null;
                 
                // gl.deleteShader(uiVertexShader);

				// return false;
			    
		   }
		else // Shader not found or failed binary block
		{
			if (src.getVertexShader(uiVertIdx).pbGLSLBinary==null)
			{
				console.log("ERROR: Vertex shader " + parserEffect.vertexShaderName  + "  not found in " + pszFileName + ".\n");
			}
			else
			{
				console.log("ERROR: Binary vertex shader " + parserEffect.vertexShaderName + " not supported.\n");
			}

			 if(bFreeVertexShader)	pszVertexShader = null;
            if(bFreeFragmentShader)	pszFragmentShader = null;
             
          
			return false;
		}
	}

	// Try first to load from the binary block
	if (src.getFragmentShader(uiFragIdx).pbGLSLBinary!==null)
	    {
            // #if defined(GL_SGX_BINARY_IMG)
            // 		if (PVRTShaderLoadBinaryFromMemory(src.GetFragmentShader(uiFragIdx).pbGLSLBinary, src.GetFragmentShader(uiFragIdx).nGLSLBinarySize,
            // 			GL_FRAGMENT_SHADER, GL_SGX_BINARY_IMG, &uiFragShader, &error) == true)
            // 		{
            // 			// success loading the binary block so we do not need to load the source
            // 			bLoadSource = 0;
            // 		}
            // 		else
            // #endif
		//{
		     	bLoadSource = 1;
		//}
	   }

	// If it fails, load from source
	if (bLoadSource)
	{
		       if(pszFragmentShader)
		{
                  //  if (PVRTShaderLoadSourceFromMemory(pszFragmentShader, gl.FRAGMENT_SHADER, uiFragShader, error) !== true)
         //if (PVRTShaderLoadSourceFromMemory(pszFragmentShader, gl.FRAGMENT_SHADER, uiFragShader) !== true)
	
		 uiFragShader =  PVRShader.loadFromMemory(gl, pszFragmentShader, gl.FRAGMENT_SHADER, []) //, uiFragShader) !== true) 
       
        //  {
		// 		console.log("ERROR: Fragment Shader compile error in file '" + pszFileName + "':\n" );
                
        //         if(bFreeVertexShader)	pszVertexShader = null;
        //         if(bFreeFragmentShader)	pszFragmentShader = null;
           
	    //        gl.deleteShader(uiFragShader);

		// 		return false;
		// 	}
		}
		else // Shader not found or failed binary block
		{
			if (src.getFragmentShader(uiFragIdx).pbGLSLBinary==null)
			{
				console.log("ERROR: Fragment shader " + parserEffect.fragmentShaderName + "  not found in " + pszFileName + ".\n");
			}
			else
			{
				console.log("ERROR: Binary Fragment shader " + parserEffect.fragmentShaderName + " not supported.\n");
			}
			if(bFreeVertexShader)	pszVertexShader = null;
            if(bFreeFragmentShader)	pszFragmentShader = null;
           
           

			return false;
		}
	}

	if(bFreeVertexShader) pszVertexShader = null;

	if(bFreeFragmentShader) pszFragmentShader =null;

	// Create the shader program
	this.m_uiProgram = gl.createProgram();
	// Attach the fragment and vertex shaders to it
	gl.attachShader(this.m_uiProgram, uiFragShader);
	gl.attachShader(this.m_uiProgram, uiVertexShader);



	// Bind vertex attributes
	for(let i = 0; i < parserEffect.attributes.length; ++i)
	{
		
		gl.bindAttribLocation(this.m_uiProgram, i, parserEffect.attributes[i].pszName);
	
	}



	//	Link the program.
	gl.linkProgram(this.m_uiProgram);
	

	// for(let i = 0; i < parserEffect.attributes.length; ++i)
	// {
	// console.log(parserEffect.attributes[i].pszName);
	// console.log("herrr")
	// console.log(gl.getAttribLocation(this.m_uiProgram, parserEffect.attributes[i].pszName));
	// }


     let  Linked =  gl.getProgramParameter(this.m_uiProgram, gl.LINK_STATUS) //&Linked);
	if (!Linked)
	{
        // let i32InfoLogLength=0;
        // let i32CharsWritten = 0;
		//let i32InfoLogLength = gl.getProgramParameter(this.m_uiProgram, gl.INFO_LOG_LENGTH);
	//	char* pszInfoLog = new char[i32InfoLogLength];
	    let pszInfoLog =	gl.getProgramInfoLog(this.m_uiProgram) //, i32InfoLogLength, &i32CharsWritten, pszInfoLog);
	   console.log("ERROR: Linking shaders in file '" , pszFileName , "':\n\n"
			, "Failed to link: " , pszInfoLog , "\n");
       // pszInfoLog = null;
      
      gl.deleteProgram(this.m_uiProgram);
		return false;
    }
    

	return true;
}

/*!***************************************************************************
 @Function			Destroy
 @Description		Deletes the gl program object and texture data.
*****************************************************************************/
 PVRPFXEffect.prototype.destroy = function(gl){

	
		if(this.m_uiProgram)
		{
			gl.deleteProgram(this.m_uiProgram);
			this.m_uiProgram = null;
		}
	

	this.m_bLoaded = false;
}

/*!***************************************************************************
 @Function			Activate
 @Returns			true if activate succeeded
 @Description		Selects the gl program object and binds the textures.
*****************************************************************************/
//</SPVRTPFXUniformSemantic></SPVRTPFXUniformSemantic> PVRPFXEffect.prototype.activate = function(const int i32RenderTextureId, const unsigned int ui32ReplacementTexture)
 PVRPFXEffect.prototype.activate = function(gl, i32RenderTextureId, ui32ReplacementTexture){
	let uiTextureId = null; //GLuint// glDeleteProgram</SPVRTPFXUniform>
	let eTarget  = 0// GLenum</SPVRTPFXTexture>

	// Set the program
	gl.useProgram(this.m_uiProgram);

	
	// Set the textures

	for(let uiTex = 0; uiTex < this.m_Textures.length; ++uiTex)
	{
		uiTextureId = this.m_Textures[uiTex].ui;
	
		if(i32RenderTextureId !== -1 && (uiTextureId === i32RenderTextureId))
			uiTextureId = ui32ReplacementTexture;

			// Set active texture unit.
		gl.activeTexture(gl.TEXTURE0 + this.m_Textures[uiTex].unit);

		// Bind texture
		eTarget = (this.m_Textures[uiTex].flags & PVRTEX_CUBEMAP ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D);
		gl.bindTexture(eTarget, uiTextureId);
	}
 
	return true;
}

                            /*!***************************************************************************
                            @Function			GetSemantics
                            @Output			aUniforms				an array of uniform data
                            @Output			pnUnknownUniformCount	unknown uniform count
                            @Input				psParams				pointer to semantic data array
                            @Input				nParamCount				number of samantic items
                            @Input				psUniformSemantics		pointer to uniform semantics array
                            @Input				nUniformSemantics		number of uniform semantic items
                            @Input				pglesExt				opengl extensions object
                            @Input				uiProgram				program object index
                            @Input				bIsAttribue				true if getting attribute semantics
                            @Output			errorMsg				error string
                            @Returns			unsigned int			number of successful semantics
                            @Description		Get the data array for the semantics.
                            *****************************************************************************/
                            // PVRPFXEffect.prototype.activate = GetSemantics(
                            // 	CPVRTArray<SPVRTPFXUniform>&				aUniforms,
                            // 	const CPVRTArray<SPVRTPFXParserSemantic>&	aParams,
                            // 	const CPVRTArray<SPVRTPFXUniformSemantic>&	aUniformSemantics,
                            // 	unsigned int*								const pnUnknownUniformCount,
                            // 	const GLuint								uiProgram,
                            // 	bool										bIsAttribue,
                            //     CPVRTString*								const errorMsg)
PVRPFXEffect.prototype.getSemantics = function( gl, 	aUniforms, aParams, aUniformSemantics,	uiProgram,	bIsAttribue)
{
//	let i, j, nCount, nCountUnused = 0;
let i = 0;
let j = 0;

	let nLocation = 0;

	/*
		Loop over the parameters searching for their semantics. If
		found/recognised, it should be placed in the output array.
	*/
    let	nCount = 0;
	let nCountUnused = 0;


	for( j = 0; j < aParams.length; ++j)
	{
		for(i = 0; i < aUniformSemantics.length; ++i)
		{
			if( aParams[j].pszValue !== aUniformSemantics[i].p)
			{
				continue;
			}

			// Semantic found for this parameter
			if(bIsAttribue)
			{
				nLocation = gl.getAttribLocation(uiProgram, aParams[j].pszName);
			}
			else
			{
				nLocation = gl.getUniformLocation(uiProgram, aParams[j].pszName);
			}
			
			if(nLocation !== null && nLocation !== -1)
			{
				let uiIdx = aUniforms.length;
                aUniforms.push(new SPVRTPFXUniform()); //unsigned int
				aUniforms[uiIdx].nSemantic	= aUniformSemantics[i].n;
				aUniforms[uiIdx].nLocation	= nLocation;
				aUniforms[uiIdx].nIdx		= aParams[j].nIdx;
				aUniforms[uiIdx].sValueName	= aParams[j].pszName;
				++nCount;
			}
			else
			{
				// console.log(aParams[j].pszName);
				// console.log(aParams[j].pszValue);
				// console.log(aUniformSemantics[i].p);
				// console.log(aUniformSemantics[i].n);
				// console.log( gl.getAttribLocation(uiProgram, aParams[j].pszName));
				// console.log(aParams[j]);
			// console.log( "WARNING: Variable not used by GLSL code: "
			// 	// + CPVRTString(aParams[j].pszName) + " "
            //     //  + CPVRTString(aParams[j].pszValue) + "\n");
            //     + aParams[j].pszName + " "
            //     + aParams[j].pszValue + "\n");
				++nCountUnused;
			}

			// Skip to the next parameter
			break;
		}
		if(i === aUniformSemantics.length)
		{
			console.log( "WARNING: Semantic unknown to application: " + aParams[j].pszValue + "\n");
			//+ CPVRTString(aParams[j].pszValue) + "\n");
		}
	}



	let pnUnknownUniformCount	= aParams.length - nCount - nCountUnused;
	//return nCount;

    return pnUnknownUniformCount;
}

/*!***************************************************************************
@Function		GetUniformArray
@Return			const CPVRTArray<SPVRTPFXUniform>&	
@Description	Returns a list of known semantics.
*****************************************************************************/
 PVRPFXEffect.prototype.getUniformArray = function() 
{
	return this.m_Uniforms;
}

/*!***************************************************************************
@Function		BuildUniformTable
@Output			uiUnknownSemantics
@Output			pReturnError
@Return			EPVRTError	
@Description	Builds the uniform table from a list of known semantics.
*****************************************************************************/
 //PVRPFXEffect.prototype.rebuildUniformTable= function(unsigned int& uiUnknownSemantics, CPVRTString* pReturnError)
 PVRPFXEffect.prototype.rebuildUniformTable= function(gl, uiUnknownSemantics)
{
	let 			nUnknownCount = 0;
	const parserEffect = this.m_pParser.getEffect(this.m_nEffect);  //SPVRTPFXParserEffect&	



	nUnknownCount  = this.getSemantics(gl, this.m_Uniforms, parserEffect.uniforms, this.m_Semantics,  this.m_uiProgram, false);
	uiUnknownSemantics	= nUnknownCount;
	
	nUnknownCount = this.getSemantics(gl, this.m_Uniforms, parserEffect.attributes, this.m_Semantics, this.m_uiProgram, true);
	uiUnknownSemantics	+= nUnknownCount;

	return true;
}

/*!***************************************************************************
@Function		RegisterUniformSemantic
@Input			psUniforms
@Input			uiNumUniforms
@Return			EPVRTError	
@Description	Registers a user-provided uniform semantic.
*****************************************************************************/
 //PVRPFXEffect.prototype.registerUniformSemantic= function(const SPVRTPFXUniformSemantic* const psUniforms, unsigned int uiNumUniforms, CPVRTString* pReturnError)
 PVRPFXEffect.prototype.registerUniformSemantic= function(gl,  psUniforms,uiNumUniforms)
 {
if(!this.m_Semantics)  this.m_Semantics =  new PVRTPFXSemanticsGetSemanticList();

	for(let uiIndex = 0; uiIndex < uiNumUniforms; ++uiIndex)
	{
	
		// Check that this doesn't already exist.
		if(this.m_Semantics.includes(psUniforms[uiIndex]))
		{
		console.log("ERROR: Uniform semantic with ID '%u' already exists.\n" + psUniforms[uiIndex].n);
			return false;
		}

		// Make copy as we need to manage the memory.
		let  pSemName = psUniforms[uiIndex].p// new char[strlen(psUniforms[uiIndex].p)+1];
		//strcpy(pSemName, );

        let uiIdx = this.m_Semantics.length;
        this.m_Semantics.push(new SPVRTPFXUniformSemantic());
		this.m_Semantics[uiIdx].n = psUniforms[uiIndex].n;
		this.m_Semantics[uiIdx].p = pSemName;
	}

	// Check if the effect has already been loaded. If it hasn't, great. If it has, we need to rebuild the uniform table.
	if(this.m_bLoaded)
	{
		// Clear the current list.
		this.m_Uniforms = [];

		let uiUnknownSemantics = 0; //unsigned int 
		return this.rebuildUniformTable(gl, uiUnknownSemantics);
	}

	return true;
}

/*!***************************************************************************
@Function		RemoveUniformSemantic
@Input			uiSemanticID
@Output			pReturnError
@Return			true on success	
@Description	Removes a given semantic ID from the 'known' semantic list and 
				re-parses the effect to update the uniform table.
*****************************************************************************/
//PVRPFXEffect.prototype.removeUniformSemantic = function(unsigned int uiSemanticID, CPVRTString* pReturnError)
PVRPFXEffect.prototype.removeUniformSemantic = function( gl, uiSemanticID){
	// Make sure that the given ID isn't a PFX semantic
	if(uiSemanticID < EPVRTPFXUniformSemantic.ePVRTPFX_NumSemantics)
	{
	console.log( "ERROR: Cannot remove a default PFX semantic.");
		return false;
	}

	// Find the index in the array
	let uiSemanticIndex = 0;
	while(uiSemanticIndex < this.m_Semantics.length && this.m_Semantics[uiSemanticIndex].n !== uiSemanticID) ++uiSemanticIndex;

	if(uiSemanticIndex === this.m_Semantics.length)
	{
		console.log("ERROR: Semantic with ID %d does not exist."+ uiSemanticID);
		return false;
	}

	this.m_Semantics.remove(uiSemanticIndex);

	// Check if the effect has already been loaded. If it hasn't, great. If it has, we need to rebuild the uniform table.
	if(this.m_bLoaded)
	{
		// Clear the current list.
		this.m_Uniforms.clear();

		let uiUnknownSemantics = 0; 
		return this.rebuildUniformTable(gl, uiUnknownSemantics);
	}

	return true;
}

/*!***************************************************************************
 @Function			GetTextureArray
 @Output			nCount					number of textures
 @Returns			SPVRTPFXTexture*		pointer to the texture data array
 @Description		Gets the texture data array.
*****************************************************************************/
 PVRPFXEffect.prototype.getTextureArray= function()   //CPVRTArray<SPVRTPFXTexture>&</SPVRTPFXUniform>
{
	return this.m_Textures;
}

/*!***************************************************************************
 @Function			SetTexture
 @Input				nIdx				texture number
 @Input				ui					opengl texture handle
 @Input				u32flags			texture flags
 @Description		Sets the textrue and applys the filtering.
*****************************************************************************/
 //PVRPFXEffect.prototype.setTexture = function(const unsigned int nIdx, const GLuint ui, const unsigned int u32flags)
 PVRPFXEffect.prototype.setTexture = function(gl, nIdx,  ui,  u32flags)
 {
	// alert("set texture");
	// alert(ui);
	// alert(this.m_Textures.length);

	if(nIdx <  this.m_Textures.length)
	{
		let u32Target = gl.TEXTURE_2D; //GLenum

		// Check if texture is a cubemap
		if((u32flags & PVRTEX_CUBEMAP) !== 0)
			u32Target = gl.TEXTURE_CUBE_MAP;

		// Get the texture details from the PFX Parser. This contains details such as mipmapping and filter modes.
		const  TexName = this.m_pParser.getEffect(this.m_nEffect).textures[nIdx].name;  //CPVRTStringHash&
		
		
		
		let iTexIdx = this.m_pParser.findTextureByName(TexName);
		if(iTexIdx === -1)
			return;

		const pPFXTex = this.m_pParser.getTexture(iTexIdx);  //SPVRTPFXParserTexture* 
			

		
		// Only change parameters if ui (handle is > 0)
		if(ui)
		{
			gl.bindTexture(u32Target, ui);

			// Set default filter from PFX file

			// --- Mipmapping/Minification
			switch(pPFXTex.nMIP)
			{
			case ETexturFilter.eFilter_None:			// No mipmapping
				switch(pPFXTex.nMin)
				{
				case ETexturFilter.eFilter_Nearest:
					gl.texParameteri(u32Target, gl.TEXTURE_MIN_FILTER, gl.NEAREST);					// Off
					break;
				case ETexturFilter.eFilter_Linear:
					gl.texParameteri(u32Target, gl.TEXTURE_MIN_FILTER, gl.LINEAR);					// Bilinear - no Mipmap
                    break;
                    default: break;
				}
				break;
			case ETexturFilter.eFilter_Nearest:		// Standard mipmapping
				switch(pPFXTex.nMin)
				{
				case ETexturFilter.eFilter_Nearest:
					gl.texParameteri(u32Target, gl.TEXTURE_MIN_FILTER, gl.NEAREST_MIPMAP_NEAREST);		// Nearest	- std. Mipmap
					break;
				case ETexturFilter.eFilter_Linear:
					gl.texParameteri(u32Target, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);		// Bilinear - std. Mipmap
                    break;
                    default: break;
				}
				break;
			case ETexturFilter.eFilter_Linear:		// Trilinear mipmapping
				switch(pPFXTex.nMin)
				{
				case ETexturFilter.eFilter_Nearest:
					gl.texParameteri(u32Target, gl.TEXTURE_MIN_FILTER, gl.NEAREST_MIPMAP_LINEAR);		// Nearest - Trilinear
					break;
				case ETexturFilter.eFilter_Linear:
					gl.texParameteri(u32Target, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);			// Bilinear - Trilinear
                    break;
                    default: break;
				}
                break;
                default: break;
			}

			// --- Magnification
			switch(pPFXTex.nMag)
			{
			case ETexturFilter.eFilter_Nearest:
				gl.texParameteri(u32Target, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
				break;
			case ETexturFilter.eFilter_Linear:
				gl.texParameteri(u32Target, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                break;
             default: break;
			}
           
			// --- Wrapping S
			switch(pPFXTex.nWrapS)
			{
			case ETextureWrap.eWrap_Clamp:
				gl.texParameteri(u32Target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
				break;
			case ETextureWrap.eWrap_Repeat:
				gl.texParameteri(u32Target, gl.TEXTURE_WRAP_S, gl.REPEAT);
                break;
             default: break;
			}
            
			// --- Wrapping T
			switch(pPFXTex.nWrapT)
			{
			case ETextureWrap.eWrap_Clamp:
				gl.texParameteri(u32Target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
				break;
			case ETextureWrap.eWrap_Repeat:
				gl.texParameteri(u32Target, gl.TEXTURE_WRAP_T, gl.REPEAT);
                break;
                default: break;
			}
           
			// --- Wrapping R
	// #ifdef gl.TEXTURE_WRAP_R
	// 		switch(pPFXTex->nWrapR)
	// 		{
	// 		case ETextureWrap.eWrap_Clamp:
	// 			gl.texParameteri(u32Target, gl.TEXTURE_WRAP_R, gl.CLAMP_TO_EDGE);
	// 			break;
	// 		case ETextureWrap.eWrap_Repeat:
	// 			gl.texParameteri(u32Target, gl.TEXTURE_WRAP_R, gl.REPEAT);
	// 			break;
	// 		}
	// #endif
		}

		// Store the texture details
		this.m_Textures[nIdx].ui	   = ui;
		this.m_Textures[nIdx].flags = u32flags;

		// Find the texture unit from the parser
		let uiIndex = this.m_pParser.findTextureIndex(pPFXTex.name, this.m_nEffect);
		if(uiIndex !== 0xFFFFFFFF)
		{
			this.m_Textures[nIdx].unit = this.m_pParser.getEffect(this.m_nEffect).textures[uiIndex].nNumber;
		}
	}
}


/*!***************************************************************************
 @Function			SetDefaultSemanticValue
 @Input				pszName				name of uniform
 @Input				psDefaultValue      pointer to default value
 @Description		Sets the default value for the uniform semantic.
*****************************************************************************/
 //PVRPFXEffect.prototype.setDefaultUniformValue= function(const char *const pszName, const SPVRTSemanticDefaultData *psDefaultValue)
 PVRPFXEffect.prototype.setDefaultUniformValue = function(gl, pszName, psDefaultValue)

{
	let nLocation = gl.getUniformLocation(this.m_uiProgram, pszName);

	switch(psDefaultValue.eType)
	{
		case ESemanticDefaultDataType.eDataTypeMat2:
			gl.uniformMatrix2fv(nLocation,  gl.FALSE, psDefaultValue.pfData);
			break;
		case ESemanticDefaultDataType.eDataTypeMat3:
			gl.uniformMatrix3fv(nLocation,  gl.FALSE, psDefaultValue.pfData);
			break;
		case ESemanticDefaultDataType.eDataTypeMat4:
			gl.uniformMatrix4fv(nLocation,  gl.FALSE, psDefaultValue.pfData);
			break;
		case ESemanticDefaultDataType.eDataTypeVec2:
			gl.uniform2fv(nLocation,  psDefaultValue.pfData);
			break;
		case ESemanticDefaultDataType.eDataTypeRGB:
		case ESemanticDefaultDataType.eDataTypeVec3:
			gl.uniform3fv(nLocation,  psDefaultValue.pfData);
			break
		case ESemanticDefaultDataType.eDataTypeRGBA:
		case ESemanticDefaultDataType.eDataTypeVec4:
			gl.uniform4fv(nLocation,  psDefaultValue.pfData);
			break;
		case ESemanticDefaultDataType.eDataTypeIvec2:
			gl.uniform2iv(nLocation,  psDefaultValue.pnData);
			break;
		case ESemanticDefaultDataType.eDataTypeIvec3:
			gl.uniform3iv(nLocation,  psDefaultValue.pnData);
			break;
		case ESemanticDefaultDataType.eDataTypeIvec4:
			gl.uniform4iv(nLocation,  psDefaultValue.pnData);
			break;
		case ESemanticDefaultDataType.eDataTypeBvec2:
			gl.uniform2i(nLocation, psDefaultValue.pbData[0] ? 1 : 0, psDefaultValue.pbData[1] ? 1 : 0);
			break;
		case ESemanticDefaultDataType.eDataTypeBvec3:
			gl.uniform3i(nLocation, psDefaultValue.pbData[0] ? 1 : 0, psDefaultValue.pbData[1] ? 1 : 0, psDefaultValue.pbData[2] ? 1 : 0);
			break;
		case ESemanticDefaultDataType.eDataTypeBvec4:
			gl.uniform4i(nLocation, psDefaultValue.pbData[0] ? 1 : 0, psDefaultValue.pbData[1] ? 1 : 0, psDefaultValue.pbData[2] ? 1 : 0, psDefaultValue.pbData[3] ? 1 : 0);
			break;
		case ESemanticDefaultDataType.eDataTypeFloat:
			gl.uniform1f(nLocation, psDefaultValue.pfData[0]);
			break;
		case ESemanticDefaultDataType.eDataTypeInt:
			gl.uniform1i(nLocation, psDefaultValue.pnData[0]);
			break;
		case ESemanticDefaultDataType.eDataTypeBool:
			gl.uniform1i(nLocation, psDefaultValue.pbData[0] ? 1 : 0);
			break;

		case ESemanticDefaultDataType.eNumDefaultDataTypes:
		case ESemanticDefaultDataType.eDataTypeNone:
		default:
			break;
	}
}

/*!***************************************************************************
@Function		SetContext
@Input			pContext
@Description	
*****************************************************************************/
 //PVRPFXEffect.prototype.setContext = function(SPVRTContext *const pContext)
 PVRPFXEffect.prototype.setContext = function( pContext)
{
	this.m_psContext = pContext;
}

/*!***************************************************************************
@Function		GetProgramHandle
@Return			unsigned int	
@Description	Returns the OGL program handle.
*****************************************************************************/
PVRPFXEffect.prototype.getProgramHandle= function()   //unsigned int </SPVRTPFXUniform>

{
	return this.m_uiProgram;
}

/*!***************************************************************************
@Function		GetEffectIndex
@Return			unsigned int	
@Description	Gets the active effect index within the PFX file.
*****************************************************************************/
 PVRPFXEffect.prototype.getEffectIndex = function()  //const //</SPVRTPFXUniformSemantic>unsigned int
{
	return this.m_nEffect;
}

/*!***************************************************************************
@Function		GetSemanticArray
@Return			const CPVRTArray<SPVRTPFXUniformSemantic>&	
@Description	Gets the array of registered semantics which will be used to
				match PFX code.
*****************************************************************************/
 PVRPFXEffect.prototype.getSemanticArray = function() //</SPVRTPFXUniformSemantic>const  //CPVRTArray<SPVRTPFXUniformSemantic>& </SPVRTPFXUniformSemantic>
{
	return this.m_Semantics;
}


return null;

}

export default PVRPFXEffect
/*****************************************************************************
 End of file (PVRTPFXParserAPI.cpp)
*****************************************************************************/

